import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../ui/tooltip';
import { isMobileContainer } from '../../../utils/device';

export default function FloatingCrmChatButton({ onClick, unreadTotal = 0, hasFeedbackButton = false }) {
  const isMobile = isMobileContainer();
  const hasUnread = unreadTotal > 0;

  const bottomClass = hasFeedbackButton
    ? 'bottom-[calc(var(--mobile-nav-offset,0px)+5rem)] md:bottom-24'
    : 'bottom-[calc(var(--mobile-nav-offset,0px)+1rem)] md:bottom-6';

  const buttonInner = (
    <button
      type="button"
      onClick={onClick}
      aria-label="CRM Chat"
      data-testid="floating-crm-chat-button"
      className={`group fixed z-50 right-4 md:right-6 ${bottomClass} flex items-center ${
        isMobile ? 'active:scale-95' : ''
      }`}
    >
      {hasUnread && (
        <span
          className="absolute inset-0 rounded-full bg-emerald-500/40 animate-ping opacity-75"
          style={{ animationDuration: '2s' }}
          aria-hidden
        />
      )}
      <span
        className={`relative flex items-center justify-center bg-emerald-600 text-white shadow-lg shadow-emerald-600/30 transition-all duration-300 hover:scale-105 hover:bg-emerald-700 hover:shadow-xl ${
          isMobile
            ? 'h-12 w-12 rounded-full'
            : 'h-14 w-14 rounded-full group-hover:w-auto group-hover:px-4 group-hover:rounded-full'
        }`}
      >
        <MessageCircle className={`h-6 w-6 shrink-0 ${isMobile ? '' : 'group-hover:mr-2'} transition-all`} />
        {!isMobile && (
          <span className="hidden group-hover:inline text-sm font-semibold whitespace-nowrap pr-1">
            CRM Chat
          </span>
        )}
        {hasUnread && (
          <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center border-2 border-background">
            {unreadTotal > 99 ? '99+' : unreadTotal}
          </span>
        )}
      </span>
    </button>
  );

  if (isMobile) {
    return buttonInner;
  }

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{buttonInner}</TooltipTrigger>
        <TooltipContent side="left">CRM Chat</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
